(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-amb-pause]').forEach(function (btn) {
    var el = document.getElementById('amb-' + btn.dataset.ambPause);
    if (!el) return;

    /* WCAG 2.2.2 — if animation is disabled by OS preference, there is nothing
       to pause. Hide the button from the accessibility tree entirely so screen
       reader users don't encounter a control that does nothing. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      btn.setAttribute('aria-hidden', 'true');
      btn.setAttribute('tabindex', '-1');
      return;
    }

    btn.addEventListener('click', function () {
      var isPaused = btn.getAttribute('aria-pressed') === 'true';
      el.classList.toggle('amb--paused', !isPaused);
      btn.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      btn.setAttribute('aria-label', isPaused ? 'Pause announcements' : 'Resume announcements');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Static block shared across all instances — select every countdown rather than a
    // section-scoped id. Each element carries its own end time via data-dh-end.
    var countdowns = document.querySelectorAll('[data-dh-countdown]');
    if (!countdowns.length) return;

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function initCountdown(el) {
      var endRaw = el.getAttribute('data-dh-end');
      if (!endRaw) return;

      // Accept "YYYY-MM-DDTHH:MM" (assumed local) and ISO strings alike.
      var endTime = new Date(endRaw).getTime();
      if (isNaN(endTime)) return;

      var daysEl = el.querySelector('[data-dh-days]');
      var hoursEl = el.querySelector('[data-dh-hours]');
      var minsEl = el.querySelector('[data-dh-mins]');
      var secsEl = el.querySelector('[data-dh-secs]');

      var timerId = null;

      function tick() {
        var diff = endTime - Date.now();

        if (diff <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minsEl.textContent = '00';
          secsEl.textContent = '00';
          if (timerId) {
            clearInterval(timerId);
          }
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var mins = Math.floor((totalSeconds % 3600) / 60);
        var secs = totalSeconds % 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minsEl.textContent = pad(mins);
        secsEl.textContent = pad(secs);
      }

      tick();
      timerId = setInterval(tick, 1000);
    }

    for (var i = 0; i < countdowns.length; i++) {
      initCountdown(countdowns[i]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-video-toggle]').forEach(function(btn) {
    var sectionId = btn.dataset.heroVideoToggle;
    var section = document.getElementById('Hero-' + sectionId);
    if (!section) return;
    btn.addEventListener('click', function() {
      var videos = section.querySelectorAll('video');
      var isPaused = btn.getAttribute('aria-pressed') === 'true';
      videos.forEach(function(video) {
        if (isPaused) { video.play(); } else { video.pause(); }
      });
      btn.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      btn.setAttribute('aria-label', isPaused ? 'Pause video' : 'Play video');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-editorial"]) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('.main-blog-editorial').forEach(function (section) {
      var cards = section.querySelectorAll('.mbe-card');
      if (!cards.length) return;

      var observer = new IntersectionObserver(function (entries) {
        var visible = Array.prototype.filter.call(entries, function (e) {
          return e.isIntersecting;
        });

        visible.sort(function (a, b) {
          var aRect = a.target.getBoundingClientRect();
          var bRect = b.target.getBoundingClientRect();
          return aRect.top !== bRect.top ? aRect.top - bRect.top : aRect.left - bRect.left;
        });

        visible.forEach(function (entry, i) {
          var card = entry.target;
          setTimeout(function () {
            card.classList.add('mbe-card--visible');
          }, i * 80);
          observer.unobserve(card);
        });
      }, { threshold: 0.08 });

      cards.forEach(function (card) {
        observer.observe(card);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-marquee-pause]').forEach(function (btn) {
    var sectionId = btn.dataset.marqueePause;
    var marqueeCmp = btn.closest('.spacing-style') || document.querySelector('marquee-component.color-' + sectionId);
    // Find the marquee-component sibling
    var controls = document.getElementById('marquee-controls-' + sectionId);
    if (!controls) return;
    var marqueeEl = controls.previousElementSibling;
    if (!marqueeEl) return;
    var wrapper = marqueeEl.querySelector('.marquee__wrapper');
    if (!wrapper) return;

    // Respect prefers-reduced-motion — start paused
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      wrapper.style.animationPlayState = 'paused';
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Resume testimonials');
    }

    btn.addEventListener('click', function () {
      var isPaused = btn.getAttribute('aria-pressed') === 'true';
      wrapper.style.animationPlayState = isPaused ? 'running' : 'paused';
      btn.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      btn.setAttribute('aria-label', isPaused ? 'Pause testimonials' : 'Resume testimonials');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["second-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sps-video-toggle]').forEach(function (btn) {
      var sectionId = btn.getAttribute('data-sps-video-toggle');
      var section = document.getElementById('second-product-showcase-' + sectionId);
      if (!section) return;
      btn.addEventListener('click', function () {
        var videos = section.querySelectorAll('video');
        var isPaused = btn.getAttribute('aria-pressed') === 'true';
        videos.forEach(function (video) {
          if (isPaused) {
            video.play();
          } else {
            video.pause();
          }
        });
        btn.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
        btn.setAttribute('aria-label', isPaused ? 'Pause video' : 'Play video');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
